<template>
    <li class="header-navigation-item"
        @mouseenter="handleLinkMouseEnter"
        @mouseleave="handleLinkMouseLeave"
    >
        <WBLink color="grey"
                :to="item.link"
                class="header-navigation-item__link"
        >
            {{ item.label }}
        </WBLink>
        <template v-if="hasMenu">
            <transition name="dropdown">
                <HeaderNavigationMenu v-show="isMenuOpen"
                                      :menu="item.menu"
                                      @mouseenter="onMenuMouseEnter"
                                      @mouseleave="onMenuMouseLeave"
                />
            </transition>
        </template>
    </li>
</template>

<script setup lang="ts">
    import type { HeaderNavigationItemType } from '~/src/widgets/header/ui/HeaderNavigation/types/types'
    import { useOverlayStore } from '~/src/shared/pinia/useOverlayStore'
    import HeaderNavigationMenu from '~/src/widgets/header/ui/HeaderNavigation/HeaderNavigationMenu.vue'

    const props = defineProps<{
        item: HeaderNavigationItemType
        isMenuOpen: boolean
    }>()

    const emit = defineEmits<{ (e: 'update-menu-state', value: boolean): void }>()

    const hasMenu = computed(() => props.item?.menu)
    const isMenuHover = ref(false)

    const applicationStore = useOverlayStore()
    const { showOverlay, hideOverlay } = applicationStore
    const handleLinkMouseEnter = () => {
        if (!hasMenu.value) {
            return
        }
        showOverlay()
        emit('update-menu-state', true)
    }

    const handleLinkMouseLeave = () => {
        if (!hasMenu.value) {
            return
        }

        if (!isMenuHover.value) {
            emit('update-menu-state', false)
            hideOverlay()
        }
    }

    const onMenuMouseEnter = () => {
        isMenuHover.value = true
    }
    const onMenuMouseLeave = () => {
        isMenuHover.value = false
    }

    onBeforeUnmount(() => {
        isMenuHover.value = false
        emit('update-menu-state', false)
        hideOverlay()
    })
</script>

<style lang="scss">
    .header-navigation-item {
        position: relative;

        &__link {
            transition: color $default-transition;
            cursor: pointer;
            user-select: none;

            @include mulish16r;
        }
    }
</style>
